export default __webpack_public_path__ + "static/media/caugiao.814d791f.png";